import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { SuperAdminUser, SuperAdminUserPost } from 'src/types/shared/SuperAdminUser';

export const updateSuperAdminUserRequest = createAction('updateSuperAdminUserRequest');
export const updateSuperAdminUserSuccess = createAction<SuperAdminUserPost>(
    'updateSuperAdminUserSuccess',
);
export const updateSuperAdminUserFailure = createAction('updateSuperAdminUserFailure');

export const updateSuperAdminUser = (id: number, postbody: SuperAdminUserPost) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(updateSuperAdminUserRequest());
    try {
        const { data }: UpdateAdminResponse = await api.patch(`admin/superadmins/${id}`, postbody);

        dispatch(updateSuperAdminUserSuccess(data));
    } catch (e) {
        handleApiErrors(dispatch, updateSuperAdminUserFailure, e);
    }
};

interface UpdateAdminResponse {
    data: SuperAdminUser;
}
